<template  lang="pug">
b-nav-item-dropdown(right='', no-caret='')
  template(slot='button-content')
    | {{staff_name}} 
    i.el-icon-menu
  b-dropdown-header.text-center(tag='div')
    strong Account
  b-dropdown-item(@click='logout')
    i.fa.fa-lock
    |  Logout
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'header-dropdown',
  data: () => {
    return {
      department: '',
      staff_name: ''
    }
  },
  mounted: function () {
    this.department = this.GET_USERDATA.department
    this.staff_name = this.GET_USERDATA.staff_name
  },
  methods: {
    ...mapActions([
      'SAVE_LOGOUT_AUTH'
    ]),
    logout () {
      this.SAVE_LOGOUT_AUTH()
      this.$router.push({path: '/login'})
    }
  },
  computed: {
    ...mapGetters([
      'GET_USERDATA'
    ])
  }
}
</script>




// WEBPACK FOOTER //
// src/components/HeaderDropdown.vue